import api from "../../../api/axios";

// Feature-local wrappers for Realty list/search/saved/profile-objects
// surfaces (Phase R2). Stateless request functions. No cache, no retry,
// no invalidation, no entity store, no shared engagement orchestrator.
//
// Backend reference: backend/app/apps/realty/{urls,views,filters,serializers}.py.
//
//   GET    /api/realty/properties/                — PropertyListSerializer page
//   POST   /api/realty/properties/{id}/like/      — toggle_like
//   POST   /api/realty/properties/{id}/bookmark/  — toggle_bookmark
//   POST   /api/realty/properties/{id}/view/      — log_view  (R2 unused)
//   DELETE /api/realty/properties/{id}/           — destroy   (R2 used from card gear)
//
// Listing endpoint understands:
//   property_type (multi)  deal_type  status         currency
//   min_price / max_price  region_code  settlement_code
//   address_object  local_area
//   rooms_min / rooms_max  min_total_area / max_total_area
//   min_land_area / max_land_area
//   has_recovery_program  has_housing_program
//   feature                                (single-id only — backend gap)
//   search (DRF SearchFilter on title + description_public)
//   ordering (DRF OrderingFilter — created_at, price, updated_at)
//   page / page_size                       (DRF pagination)
//
// The list response shape is paginated: { count, next, previous, results }.
// The toolbar count strong-emphasis binds directly to `count`.

const REALTY_BASE = "/realty";

export const fetchProperties = (params, options = {}) =>
  api
    .get(`${REALTY_BASE}/properties/`, {
      params,
      signal: options.signal,
    })
    .then((res) => res.data);

export const togglePropertyLike = (id) =>
  api.post(`${REALTY_BASE}/properties/${id}/like/`).then((res) => res.data);

export const togglePropertyBookmark = (id) =>
  api
    .post(`${REALTY_BASE}/properties/${id}/bookmark/`)
    .then((res) => res.data);

export const deleteProperty = (id) =>
  api.delete(`${REALTY_BASE}/properties/${id}/`).then((res) => res.data);

// Status mutation — covers "Зняти з публікації" / "Позначити як продане"
// / "В архів" launched from the per-card gear modal and from
// editRealty.html management zone. Uses the same PATCH endpoint as a
// regular property update, restricted to the `status` field. Backend
// validation lives in PropertyWriteSerializer.validate_status (blocks
// non-staff reactivation of archived rows).
export const patchPropertyStatus = (id, status) =>
  api
    .patch(`${REALTY_BASE}/properties/${id}/`, { status })
    .then((res) => res.data);
